module.exports = __webpack_public_path__ + "images/img-Va6ZO8A.png";


//////////////////
// WEBPACK FOOTER
// ./frontend/cabinets/apps/rocket/assets/img/keitaro-integration/en/8.png
// module id = 2344
// module chunks = 0